import { LoginForm } from 'components/LoginForm/LoginForm';

const LoginPage = () => {
  return (
    <div>
      LoginPage
      <LoginForm />
    </div>
  );
};

export default LoginPage;
